import { Component, OnInit, Input } from '@angular/core';
import { SecurityContext } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../notification.service';

@Component({
  selector: 'lib-view-notification',
  templateUrl: './view-notification.component.html',
  styleUrls: ['./view-notification.component.scss']
})
export class ViewNotificationComponent implements OnInit {

  dropDownList: any = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Communication' },
    { id: 3, name: 'Compliant' },
    { id: 4, name: 'Message' },
  ];

  dataSource: any;
  curMsg: any;
  selectedIndex: number;
  searchWord: string = '';
  timer: any;
  hours: any;
  minutes: any;
  seconds: any;
  offerSDate: string;
  offerSTime: any;
  timerStarted: boolean;
  isNotFound: boolean;
  tempSource: any;
  days: any;
  userId: any;
  notifyTitle:string='Messages';
  offerMsg: string = "No offer msg";
  offerTimer: string;
  showtimer: boolean;
  receivedDS: any;
  commDS: any = [];
  alertDS: any = [];
  notiDS: any = [];
  alertDSCount: number;
  notiDSCount: number;
  commDSCount: number;
  curIndex: number;
  selectedIndexMenu:number=0;
  noMsg: string = 'communications';
  @Input() applicationID:string='1';
  envLink: any = this._http.apiUrl + 'CommunicationAssets/DownloadAsset/';
  constructor(private location: Location,
    private datePipe: DatePipe,
    private sanitizer:DomSanitizer,
    public translate: TranslateService,
    private _http: NotificationService) { }

  ngOnInit() {
    this._http.getAllNotification(this._http.appProfile,this.applicationID).subscribe({
      next: (data: any) => {
        if (data) {
          this.receivedDS = data.messageResponses;
          this.commDS = this.receivedDS.filter(x => x.messageType == 'Message');
          this.notiDS = this.receivedDS.filter(x => x.messageType == 'Update');
          this.alertDS = this.receivedDS.filter(x => x.messageType == 'Alert');
          this.dataSource = this.commDS;
          //console.log('receivedBs',this.receivedDS);
          this.addIcon();
          this.isNotFound = false;
        }
        else {
          this.isNotFound = true;
        }
      },
      error: err => { },
      complete: () => { }
    })
    //this._http.currentNotifications.subscribe();
    //this.getNotificationsFromBS();
    //this.getInstitutionId();
  }

  getNotificationsFromBS() {
    // this.adminService.currentNotifications.subscribe({
    //   next: (data: any) => {
    //     this.receivedDS = data;
    //     if (this.receivedDS.length > 0) { this.addIcon(); }
    //   },
    //   error: err => { },
    //   complete: () => { }
    // });
  }
  addIcon() {
    this.receivedDS.forEach(element => {
      element.iconName = '';
      if (element.messageTime != '') { element.messageTime = this._http.timeCon24To12(element.messageTime); }
    });
    this.receivedDS.filter((data: any) => {
      if (data.messageType == 'Message') {
        data.iconName = 'Message';
      }
      else if (data.messageType == 'Update') {
        data.iconName = 'Update';
      }
    })

    // front-end filter DS and DS count

    // this.alertDS = this.receivedDS.filter(x => x.notificationType == 'Alert');
    // this.notiDS = this.receivedDS.filter(x => x.notificationType == 'Notification');
    // this.commDS = this.receivedDS.filter(x => x.notificationType == "Communication");

    // let getAlertUnreadSource = this.alertDS.filter(x => x.isRead == false);
    // this.alertDSCount = getAlertUnreadSource.length;

    // let getNotiUnreadSource = this.notiDS.filter(x => x.isRead == false);
    // this.notiDSCount = getNotiUnreadSource.length;

    // let getCommUnreadSource = this.commDS.filter(x => x.isRead == false);
    // this.commDSCount = getCommUnreadSource.length;

    //console.log(this.alertDS, this.notiDS, this.commDS, this.commDSCount);
    // front-end filter DS and DS count 

    //this.dataSource = this.commDS;
    //this.curMsg = this.dataSource[0];
    if(this.dataSource.length)
    this.curMsgClick(this.dataSource[0]);
    this.selectedIndex = 0;
    this.showTimer();
  }
  tabClick(tab) {
    this.curIndex = tab.index;
    switch (this.curIndex) {
      case 0: this.dataSource = this.receivedDS;this.noMsg = 'communications';
        break;
      case 1: this.dataSource = [];this.noMsg = 'notifications';
        break;
      case 2: this.dataSource = [];this.noMsg = 'alerts';
        break;
    }
  }
  redirectToNotify(index) {
    this.selectedIndexMenu = index;
    if(index == 1){
      this.dataSource = this.notiDS;
      this.notifyTitle = 'Updates';
      this.curMsgClick(this.dataSource[0]);
    }else if(index == 0){
      this.dataSource = this.commDS;
      this.notifyTitle = 'Messages';
      this.curMsgClick(this.dataSource[0]);
    } else if(index == 2){
      this.dataSource = this.alertDS;
      this.notifyTitle = 'Alerts';
      this.curMsgClick(this.dataSource[0]);
    }
  }
  getInstitutionId() {
    // this.userDetails.currentUserData.subscribe({
    //   next: (data: any) => {
    //     this.userId = data.insUserId;
    //   },
    //   error: err => {
    //   },
    //   complete: () => { }
    // });
  }
  curMsgClick(curmsg) {
    if(curmsg == undefined){
      this.curMsg = {};
      return false;
    }
    this.removeTimer();
    //this.curMsg = curmsg;
    let curSelectionId = curmsg.messageId;
    this.selectedIndex = this.dataSource.findIndex(x => x.messageId === curSelectionId);
    const updateData: any = {
      messageId: curSelectionId,
      //isRead: true,
    };
    if (this.curMsg.isRead == false) { this.isRead(this.userId, updateData); } // mark is read true
    //this.showTimer();
    let formData = {
      MessageId:curmsg.messageId,
      userId:""
    }
    this._http.getMessageById(curmsg.messageId).subscribe({
      next: (data: any) => {
        this.curMsg = data;
        this.showTimer();
        this.getAssetPath(this.curMsg);
        this._http.updateNotifyData(formData).subscribe({
          next: (data: any) => {
            this._http.getNotification(this._http.appProfile,this.applicationID).subscribe(data1 =>{
              if(data1){
                this._http.notificationCount.next(data1[0].messageResponses.length);
              }
            })
          },
          error: err => {
           },
          complete: () => { }
        });
      },
      error: err => {
       },
      complete: () => { }
    })
  }
  sanitize(html){
    return this.sanitizer.sanitize(SecurityContext.HTML,html)
  }
  
  showTimer() {
    if(this.curMsg.offerStartDate == ''){this.curMsg.offerStartTime = '00:00';}
    if(this.curMsg.offerEndDate == ''){this.curMsg.offerEndTime = '00:00';}
    if (this.curMsg.messageType == 'Update' && this.curMsg.updateType != 'General news' 
    && this.curMsg.updateType != 'Product launch' && this.curMsg.updateType != 'Product deletion') {
      if (this.curMsg.offerStartDate !== null && this.curMsg.offerEndDate !== null) {

        this.offerSDate = this.datePipe.transform(this.curMsg.offerStartDate, 'longDate');
        this.offerSTime = this._http.timeCon24To12(this.curMsg.offerStartTime);

        // this.offerSDate = this.datePipe.transform(this.curMsg.offerStartDate, 'yyyy-MM-dd');
        // this.offerSTime = this.curMsg.offerStartTime;

        let d1 = this.curMsg.offerStartDate = this.curMsg.offerStartDate.split('T')[0];
        this.curMsg.offerStartDate = d1.concat('T', this.curMsg.offerStartTime, ':00Z'); // replacing time(inside date) into offer start time
        let sTime = this.curMsg.offerStartDate.split('Z')[0];

        let d2 = this.curMsg.offerEndDate = this.curMsg.offerEndDate.split('T')[0];
        this.curMsg.offerEndDate = d2.concat('T', this.curMsg.offerEndTime, ':00Z'); // replacing time(inside date) into offer end time
        let eTime = this.curMsg.offerEndDate.split('Z')[0];
        this.offerMsg = '';
        this.showtimer = true;

        if (!(new Date(sTime).getTime() <= new Date().getTime() && new Date(eTime).getTime() <= new Date().getTime())) { // offer already started and already end
          this.timer = setInterval(() => {
            this.timeBetweenDates(eTime);
          }, 1000);
        }
        if (new Date(eTime).getTime() <= new Date().getTime()) { // offer already ended                                                                                     
          this.offerMsg = 'Offer expired';
          this.showtimer = false;
        }
        if (new Date(sTime).getTime() > new Date().getTime()) { // offer going to start
          this.showtimer = false;
          this.offerMsg = 'Offer starts from' + ' ' + this.offerSDate + ' ' + this.offerSTime;
        }
      }
    }
  }
  isRead(userid, updateData) {
    // this.adminService.updateNotification(userid, updateData).subscribe({
    //   next: (data: any) => { },
    //   error: err => { },
    //   complete: () => { }
    // });
  }
  closeNotification() {
    this.removeTimer();
    this.location.back();
  }
  removeSearchText() {
    this.searchWord = '';
  }
  changeDropDown(curSelName: any) {
    if (curSelName == 'All') {
      this.dataSource = this.tempSource;
      this.isNotFound = false;
    }
    else {
      let dropDownData = this.tempSource.filter(x => x.notificationType === curSelName);
      this.dataSource = dropDownData;
      if (this.dataSource.length == 0) {
        this.isNotFound = true;
      }
      else {
        this.isNotFound = false;
      }
    }
  }
  timeBetweenDates(etime) {
    let difference = new Date(etime).getTime() - new Date().getTime();
    if (difference <= 0) {
      this.offerMsg = 'Offer expired';
      this.showtimer = false;
      this.removeTimer();
    } else {
      this.seconds = Math.floor(difference / 1000);
      this.minutes = Math.floor(this.seconds / 60);
      this.hours = Math.floor(this.minutes / 60);
      this.days = Math.floor(this.hours / 24);
      this.hours %= 24;
      this.minutes %= 60;
      this.seconds %= 60;
      this.days = this.days.toLocaleString(undefined,{minimumIntegerDigits: 2});
      this.hours = this.hours.toLocaleString(undefined,{minimumIntegerDigits: 2});
      this.minutes = this.minutes.toLocaleString(undefined,{minimumIntegerDigits: 2});
      this.seconds = this.seconds.toLocaleString(undefined,{minimumIntegerDigits: 2});
      let daycount;
      let leftMsg;
      if (this.days > 0) { daycount = this.days + ' ' + 'days'; leftMsg = 'Left'; } else { daycount = ''; leftMsg = 'Time left' }
      this.offerTimer = daycount + ' ' + this.hours + ':' + this.minutes + ':' + this.seconds + ' ' + leftMsg;
    }
  }
  getAssetPath(communicationSource) {
    if (!!communicationSource) {
      // this.curMsg.forEach(element => {
      //   element.newAssetPath = '';
      // });
      // for (let i = 0; i < communicationSource.length; i++) {
        if (communicationSource.assetPath != null && communicationSource.assetPath != undefined) {
          let path = communicationSource.assetPath.split("/");
          this.curMsg.newAssetPath = path[path.length - 1];
        }
      //}
    }
  }
  removeTimer() {
    this.curMsg = {};
    clearInterval(this.timer);
    this.offerTimer = '';
  }
}
